import ProductItem from '../../../components/shop/ProductItem';

interface Props {
    items: []
}

const Products: React.FC<Props> = (props) => {
    return <>
        {props.items?.map((item: any) => {
            return <ProductItem
                key={`product-item-${item.id}`}
                link={"/shop/" + item.id}
                id={item.id}
                title={item.name}
                image={item.image}
                price={item.price}
                oldPrice={item.old_price}
                progress={item.progress} />
        })}
    </>
}

export default Products